import { Badge, Typography, useTheme } from "@material-ui/core";
import useStyles from "../styles";
import { LiteBox } from "../../../components/lite/LiteBox";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import ListIcon from "../../../components/icons/Controls/ListIcon";
import { primaryActive, tableText } from "../../../hooks/use-map-theme-styles";
import DnsOutlinedIcon from "@material-ui/icons/DnsOutlined";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { FeatureEncapsulationIcon } from "../../../components/icons/FeatureEncapsulationIcon";
import { useBusinessCaseFeature } from "../hooks/use-business-case-feature";
import ComparisonIcon from "../../../components/icons/Comparison";

interface ICustomToggleButtonProps {
	value: string;
	title: string;
	label: string;
	className: string;
	renderContent: (selected: boolean) => JSX.Element;
	addOn?: () => JSX.Element;
	disabled?: boolean;
}

const CustomToggleButton = (props: ICustomToggleButtonProps) => {
	const { value, title, label, renderContent, className, disabled, addOn, ...other } = props;
	const { palette } = useTheme();
	const isSelected = value === title;

	return (
		<ToggleButton
			style={{
				backgroundColor: isSelected ? palette.background.paper : "transparent",
				pointerEvents: disabled ? "stroke" : "auto",
			}}
			className={className}
			value={title}
			disabled={disabled}
			{...other}
		>
			{renderContent(isSelected)}
			{isSelected && (
				<Typography style={{ marginLeft: "10px", fontWeight: "600" }} variant="body1" color={"primary"}>
					{label}
				</Typography>
			)}
			<span>{!!addOn && addOn()}</span>
		</ToggleButton>
	);
};

interface IViewSwitcherProps {
	numberOfSimulations: number;
}

export const ViewSwitcher = (props: IViewSwitcherProps) => {
	const { toggleContainer, toggleRoot, toggleIconButton } = useStyles();
	const { push } = useHistory();
	const { t } = useTranslation();
	const { isBusinessCaseEnabled } = useBusinessCaseFeature();
	const paths = window.location.pathname.split("/").filter(Boolean);
	const value = paths[paths.length - 1];
	const buttonProps = [
		{
			title: "simulator",
			label: t("view-switcher-list"),
			renderContent: (selected: boolean) => <ListIcon fill={selected ? primaryActive : ""} />,
		},
		{
			title: "groups",
			label: t("view-switcher-groups"),
			disabled: !isBusinessCaseEnabled,
			renderContent: (selected: boolean) => <DnsOutlinedIcon htmlColor={selected ? primaryActive : tableText} />,
			addOn: () =>
				isBusinessCaseEnabled ? (
					<></>
				) : (
					<FeatureEncapsulationIcon wrapStyles={{ position: "relative", top: 3 }} toolTipText={"view-switcher-groups-disabled"} />
				),
		},
		{
			title: "comparison",
			label: t("view-switcher-comparison"),
			renderContent: (selected: boolean) => (
				<Badge badgeContent={props.numberOfSimulations} color="primary">
					<ComparisonIcon isActive={selected} />
				</Badge>
			),
		},
	];

	const handleAlignment = (_event: any, newAlignment: string) => {
		if (newAlignment) {
			const route = newAlignment === "simulator" ? "/simulator" : `/simulator/${newAlignment}`;
			push(route);
		}
	};

	return (
		<LiteBox className={toggleContainer}>
			<ToggleButtonGroup className={toggleRoot} value={value} exclusive onChange={handleAlignment}>
				{buttonProps.map((buttonProp) => (
					<CustomToggleButton value={value} {...buttonProp} className={toggleIconButton} />
				))}
			</ToggleButtonGroup>
		</LiteBox>
	);
};
